<template>
    <v-container class="py-12">
        <v-row>
            <v-col :cols="12">
                <div class="title-container">
                    <div class="title-block">
                        <span id="title" class="page-title">Centros de Custo</span>
                        <v-breadcrumbs class="app-breadcrumb" divider="›" :items="[
                            {
                                text: 'Home',
                                disabled: false,
                                to: '/home',
                                exact: true,
                            },
                            {
                                text: 'Centros de custo',
                                disabled: true,
                                exact: true,
                            },
                        ]"></v-breadcrumbs>
                    </div>
                    <div class="button-group">
                        <v-btn v-if="$check(['costcenters.create'])" id="btnNew" type="button" color="primary" elevation="0"
                            to="/centro-custo/novo">Incluir</v-btn>
                    </div>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card class="filter-card">
                    <v-card-title class="filter-card-title">Filtros de busca</v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="load()">
                            <v-row>

                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Código" v-model="dataList.filter.code" hide-details
                                        outlined></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                    <v-text-field dense label="Empresa" v-model="dataList.filter.customer" hide-details
                                        outlined></v-text-field>
                                </v-col>

                            </v-row>

                            <v-row>
                                <v-col cols="12">
                                    <v-btn id="btnFilter" type="submit" color="primary" dark
                                        elevation="2">Aplicar filtros</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-card-text>
                        <v-data-table :headers="dataList.headers" :items="dataList.data"
                            @update:items-per-page="pageSizeChanged" @update:page="pageChanged"
                            :server-items-length="dataList.count" :disable-sort="true" :loading="dataList.loading"
                            no-data-text="Nenhum solicitante encontrado" loading-text="Carregando dados..."
                            class="app-table hover-table" :options.sync="dataList.options"
                            :footer-props="dataList.footerOptions">

                            <template v-slot:[`item.customer`]="{ item }">
                                <span>{{ item.customer ? item.customer.name : 'N/A' }}</span>
                            </template>

                            <template v-slot:[`item.actions`]="{ item }">
                                <v-row align="center">

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['costcenters.update'])" class="ml-2" v-on="on" @click="viewItem(item)" size="large">
                                                mdi-pencil-outline
                                            </v-icon>
                                        </template>
                                        <span>Editar centro de custo</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template #activator="{ on }">
                                            <v-icon v-if="$check(['costcenters.delete'])" class="ml-2" v-on="on" @click="deleteItem(item)" size="large">
                                                mdi-delete
                                            </v-icon>
                                        </template>
                                        <span>Remover centro de custo</span>
                                    </v-tooltip>

                                </v-row>
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>

                <v-divider></v-divider>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

import object from "@/common/util/object"

Vue.use(VueLodash)

export default {
    name: "RequestList",

    data: () => ({
        dataset: {
            data: {},
            customers: []
        },
        dataList: {
            filter: {
                name: "",
            },
            headers: [
                { text: "ID", value: "id" },
                { text: "Código", value: "code" },
                { text: "Empresa", value: "customer" },
                { text: 'Ações', value: 'actions', sortable: false },
            ],
            data: [],
            loading: false,
            count: 0,
            options: {
                page: 1,
                size: 10,
                sortBy: ['id'],
                sortDesc: [false],
            },
            footerOptions: {
                itemsPerPageText: 'Itens por página:',
                itemsPerPageOptions: [10, 20, 30, 40, 50],
                pageText: '{0}-{1} de {2}',
            },
        },
    }),

    created() {
        this.load();
    },

    methods: {
        pageChanged(page) {
            this.dataList.options.page = page;
            this.load();
        },

        pageSizeChanged(size) {
            this.dataList.options.size = size;
            this.load(true);
        },

        async load() {

            let search = Object.fromEntries(Object.entries(this.dataList.filter).filter(([_, v]) => v))

            search = !object.isEmpty(search) ? search : null;

            var limit = this.dataList.options.size;
            var page = this.dataList.options.page;

            this.dataList.loading = true;

            try {
                const result = await axios.get(`/api/v2/cost-centers`, {
                    params: {
                        page: page,
                        limit: limit,
                        search
                    }
                });

                this.dataList.data = result.data.content.data;
                this.dataList.count = result.data.content.total;

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), { position: 'top-right', timeout: 5000 });
            } finally {
                this.dataList.loading = false;
            }

        },

        viewItem(item) {
            this.$router.push(`centro-custo/${item.id}`);
        },

        async deleteItem(item) {

            if (!item || !item.id) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Tem certeza que deseja continuar?',
                title: 'Excluir centro de custo',
                actions: {
                    false: 'Cancelar',
                    true: 'Excluir'
                }
            })

            if (!proceedAction) return;

            this.dataList.loading = true

            try {

                const result = await axios.delete(`api/v2/cost-centers/${item.id}`)

                this.$dialog.notify.info("Centro de custo excluído com sucesso!", { position: "top-right", timeout: 2000 });

                this.load()

            } catch (error) {

                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })

            } finally {
                this.dataList.loading = false;
            }

        },

    },
};
</script>